<script setup lang="ts">
    import type { ComputedRef } from 'vue';
    import type { Notification } from '@shopware/composables';

    const props = defineProps<{
        notification: Notification;
    }>();

    defineEmits<{
        (e: 'click:close', id: number): void;
    }>();

    const { t } = useI18n();

    const colorCssMap = {
        info: 'blue',
        success: 'green',
        warning: 'orange',
        danger: 'red'
    };

    const themeTypeColor: ComputedRef<string> = computed(() => colorCssMap[props.notification.type] || 'blue');
</script>
<template>
    <div
        v-if="notification.message.length > 0"
        :id="`toast-${notification.id}`"
        :data-testid="`notification-element-${notification.type}`"
        class="notification"
        role="alert"
    >
        <div class="wrapper">
            <div
                class="icon-wrapper"
                :class="`--${themeTypeColor}`"
            >
                <img
                    v-if="notification.type === 'info'"
                    src="~/assets/icons/info.svg"
                    alt="Notification Icon"
                    aria-hidden="true"
                />
                <img
                    v-if="notification.type === 'success'"
                    src="~/assets/icons/check-black.svg"
                    alt="Notification Icon"
                    aria-hidden="true"
                />
                <img
                    v-if="notification.type === 'warning'"
                    src="~/assets/icons/warning.svg"
                    alt="Notification Icon"
                    aria-hidden="true"
                />
                <img
                    v-if="notification.type === 'danger'"
                    src="~/assets/icons/warning.svg"
                    alt="Notification Icon"
                    aria-hidden="true"
                />
            </div>
            <div
                data-testid="notification-element-message"
                class="message"
            >
                {{ notification.message }}
            </div>
        </div>

        <SharedCloseButton
            :data-dismiss-target="`toast-${notification.id}`"
            :label="t('close')"
            @click="$emit('click:close', notification.id)"
        />
    </div>
</template>

<style scoped>
    @import '~/assets/scss/notifications/layout-notification.scss';
</style>
